// Blog posts data
const blogsData = [
  {
    id: "1",
    title: "25 n8n Tips and Hidden Features to Speed Up Your Workflow",
    date: "Mar 18, 2026",
    author: "vBlog Team",
    excerpt:
      "Automation platforms like n8n are powerful, but the difference between a beginner and an expert often lies in knowing the small shortcuts and hidden settings that save time. Unlock the full potential of n8n with these twenty-five essential tips and hidden features.",
    readTime: "8 min read",
    image: "https://images.unsplash.com/photo-1518770660439-4636190af475?w=800&q=80",
    topic: "n8n",
    category: "Automation",
    keywords: ["n8n tips", "n8n hidden features", "workflow automation", "n8n tutorial", "ai agents", "n8n expressions"],
  },
  {
    id: "2",
    title: "18 n8n Tips and Hacks to Optimize Your Workflow Automation",
    date: "Mar 18, 2026",
    author: "vBlog Team",
    excerpt:
      "Automation tools like n8n have transformed how businesses handle repetitive tasks. However, as workflows grow in complexity, they can become slow, difficult to manage, or expensive to run. We've compiled 18 essential tips and hacks to improve execution speed, integrate cutting-edge AI, and maintain a clean, professional workspace.",
    readTime: "9 min read",
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=800&q=80",
    topic: "n8n",
    category: "Automation",
    keywords: ["n8n tips", "workflow automation", "n8n tutorial", "ai automation", "n8n sub-workflows", "n8n rag"],
  },
  {
    id: "3",
    title: "How to Connect Facebook Graph API to n8n: A Complete Guide",
    date: "Mar 22, 2026",
    author: "vBlog Team",
    excerpt:
      "Automating your social media presence can save hours of manual work. By connecting the Facebook Graph API to n8n, you can automate tasks like publishing posts, managing comments, and tracking engagement. This guide provides a clear, step-by-step path to setting up this connection safely and efficiently.",
    readTime: "9 min read",
    image: "https://images.unsplash.com/photo-1611262588024-d12430b98920?w=800&q=80",
    topic: "Facebook Graph API",
    category: "Automation",
    keywords: ["facebook graph api", "n8n automation", "meta for developers", "access token", "facebook api integration", "graph api explorer"],
  },
  {
    id: "4",
    title: "7 Best Manus AI Use Cases to Automate Your Business and Life",
    date: "Mar 30, 2026",
    author: "vBlog Team",
    excerpt:
      "The era of AI that simply answers questions is evolving into an era of AI that executes tasks. Manus AI changes this dynamic. As a powerful new AI agent, it functions as a 24/7 digital employee capable of browsing the web, clicking buttons, and managing complex workflows autonomously.",
    readTime: "9 min read",
    image: "https://images.unsplash.com/photo-1677442135703-1787eea5ce01?w=800&q=80",
    topic: "Manus AI",
    category: "Automation",
    keywords: ["manus ai", "ai agent", "business automation", "automated lead generation", "ai headhunting", "digital employee"],
  },
  {
    id: "5",
    title: "8 Expert Secrets to Master Claude Code: Source Code Insights",
    date: "Apr 01, 2026",
    author: "vBlog Team",
    excerpt:
      "The developer community was recently shaken when Anthropic accidentally leaked the source code for Claude Code through an npm package source map. This leak exposed over 500,000 lines of production-grade code, providing an unprecedented look into how one of the world's most advanced AI coding tools actually functions.",
    readTime: "8 min read",
    image: "https://images.unsplash.com/photo-1555949963-ff9fe0c870eb?w=800&q=80",
    topic: "Claude Code",
    category: "Coding",
    keywords: ["claude code", "anthropic", "ai coding tools", "model context protocol", "agentic workflows", "claude.md"],
  },
  {
    id: "6",
    title: "Mastering Claude Code Routines: Automate Your AI Workflow",
    date: "Apr 16, 2026",
    author: "vBlog Team",
    excerpt:
      "Anthropic recently introduced Routines for Claude Code. Released in research preview, this feature allows developers to move beyond manual prompting and local sessions, enabling AI agents to perform complex tasks on a schedule or in response to specific triggers.",
    readTime: "3 min read",
    image: "https://images.unsplash.com/photo-1620712943543-bcc4688e7485?w=800&q=80",
    topic: "Claude Code",
    category: "Automation",
    keywords: ["claude code routines", "anthropic", "ai automation", "ai agents", "github integration", "developer tools"],
  },
  {
    id: "7",
    title: "How to Set Up OpenClaw: Build Your Own Autonomous AI Agent",
    date: "Mar 18, 2026",
    author: "vBlog Team",
    excerpt:
      "Learn how to build and host OpenClaw, a powerful autonomous AI agent. This comprehensive guide covers VPS installation, Telegram integration, and skill expansion to help you deploy a fully operational AI agent.",
    readTime: "8 min read",
    image: "https://images.unsplash.com/photo-1485827404703-89b55fcc595e?w=800&q=80",
    topic: "OpenClaw",
    category: "Automation",
    keywords: ["openclaw", "autonomous ai agent", "vps setup", "telegram bot", "ai automation", "self-hosted ai"],
  },
  {
    id: "8",
    title: "Mastering Scheduled Tasks in Claude Code: A Complete Guide",
    date: "Mar 18, 2026",
    author: "vBlog Team",
    excerpt:
      "Discover how to automate your workflow using Scheduled Tasks in Claude Code. This guide covers setting up self-healing AI agents, overcoming hardware limitations, and running autonomous tasks around the clock.",
    readTime: "7 min read",
    image: "https://images.unsplash.com/photo-1633356122544-f134324a6cee?w=800&q=80",
    topic: "Claude Code",
    category: "Automation",
    keywords: ["claude code", "scheduled tasks", "ai automation", "self-healing agents", "anthropic", "developer tools"],
  },
  {
    id: "9",
    title: "How to Use Claude Co-work to Automate Your Daily Workflow",
    date: "Mar 6, 2026",
    author: "vBlog Team",
    excerpt:
      "Discover how Claude Co-work transforms productivity by moving from basic assistance to active execution. This guide explores how to automate file management, calendar scheduling, and multi-step workflows with Claude.",
    readTime: "6 min read",
    image: "https://images.unsplash.com/photo-1552664730-d307ca884978?w=800&q=80",
    topic: "Claude Co-work",
    category: "Automation",
    keywords: ["claude co-work", "workflow automation", "productivity", "anthropic", "ai assistant", "task automation"],
  },
  {
    id: "10",
    title: "How to Run Claude Code Offline for Free Using Ollama",
    date: "Feb 23, 2026",
    author: "vBlog Team",
    excerpt:
      "Learn how to run Claude Code offline for free using Ollama. This step-by-step guide explains how to set up local LLMs like Qwen2.5-Coder to enhance privacy, reduce costs, and work without an internet connection.",
    readTime: "9 min read",
    image: "https://images.unsplash.com/photo-1667372393119-3d4c48d07fc9?w=800&q=80",
    topic: "Ollama",
    category: "Coding",
    keywords: ["ollama", "claude code offline", "local llm", "qwen2.5-coder", "privacy", "free ai"],
  },
];

export default blogsData;
